import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, DatePicker, Select, TextInput } from 'components/Form'
import { createApiRecord, updateApiRecord } from 'services/FuelLevyService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Error, Success } from 'utils/alerts'
import dayjs from 'dayjs'
import {
    getTransportProviderData,
    getTransportProviderServiceData,
} from 'store/data/dataSlice'
import { phoneCountryCodeOptions } from 'utils/options'
injectReducer('fuelLevy', reducer)

const validationSchema = Yup.object().shape({
    company: Yup.number().required('Please select company'),
    client: Yup.number().nullable(),
    transport_provider: Yup.number().required(
        'Please select transport provider',
    ),
    services: Yup.array().required('Please select tranport provider services'),
    country_code: Yup.string().required('Country Code required'),
    from_date: Yup.date().required('From date is required'),
    to_date: Yup.date().required('To date required'),
    percentage: Yup.number().required('Percentage is required'),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {
        companyData,
        clientCompanyData,
        transportProviderData,
        transportProviderServiceData,
    } = useSelector((state) => state.listData)
    const { view, record, loading } = useSelector(
        (state) => state.fuelLevy.data,
    )

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = (id) => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/master-data/fuel-levy')

    const handleSubmit = (values, setSubmitting) => {
        values.from_date = dayjs(values.from_date).format('YYYY-MM-DD')
        values.to_date = dayjs(values.to_date).format('YYYY-MM-DD')
        setSubmitting(true)
        if (id) {
            updateApiRecord(id, values)
                .then(() => {
                    Success('Updated Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    error.response.data?.errors.map((err) => Error(err.message))
                    setSubmitting(false)
                    return error
                })
        } else {
            createApiRecord(values)
                .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    error.response.data?.errors.map((err) => Error(err.message))
                    setSubmitting(false)
                    return error
                })
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Fuel Levy
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-lg border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id ? 'Update Fuel Levy' : 'Add New Fuel Levy'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, touched, errors, isSubmitting }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                        <Field name="company">
                                            {({ field, form }) => (
                                                <Select
                                                    options={companyData}
                                                    label="Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="company"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.company &&
                                                        touched.company
                                                    }
                                                    message={errors.company}
                                                    value={values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                        form.setFieldValue(
                                                            'client',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'transport_provider',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'service',
                                                            '',
                                                        )
                                                        dispatch(
                                                            getTransportProviderData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                        dispatch(
                                                            getTransportProviderServiceData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="client">
                                            {({ field, form }) => (
                                                <Select
                                                    options={clientCompanyData?.filter(
                                                        (item) =>
                                                            item?.client &&
                                                            item?.company?.id.toString() ===
                                                                values?.company,
                                                    )}
                                                    label="Client Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="client"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.client &&
                                                        touched.client
                                                    }
                                                    message={errors.client}
                                                    value={values?.client}
                                                    disabled={!values?.company}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="transport_provider">
                                            {({ field, form }) => (
                                                <Select
                                                    options={transportProviderData?.filter(
                                                        (item) =>
                                                            item.type ===
                                                            'Aggregator',
                                                    )}
                                                    label="Transport Provider"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="transport_provider"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.transport_provider &&
                                                        touched.transport_provider
                                                    }
                                                    message={
                                                        errors.transport_provider
                                                    }
                                                    value={
                                                        values?.transport_provider
                                                    }
                                                    disabled={!values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        {id ? (
                                            <Field name="services">
                                                {({ field, form }) => (
                                                    <Select
                                                        options={
                                                            transportProviderServiceData
                                                        }
                                                        label="Transport Provider Service"
                                                        size="sm"
                                                        placeholder="Select"
                                                        name="services"
                                                        className="md:col-span-2"
                                                        error={
                                                            errors.services &&
                                                            touched.services
                                                        }
                                                        message={
                                                            errors.services
                                                        }
                                                        value={values?.services}
                                                        disabled={
                                                            !values?.company
                                                        }
                                                        onChange={(e) =>
                                                            form.setFieldValue(
                                                                field.name,
                                                                e.target.value
                                                                    ? [
                                                                          e
                                                                              .target
                                                                              .value,
                                                                      ]
                                                                    : [],
                                                            )
                                                        }
                                                    />
                                                )}
                                            </Field>
                                        ) : (
                                            <Field name="services">
                                                {({ field, form }) => (
                                                    <Select
                                                        options={
                                                            transportProviderServiceData
                                                        }
                                                        label="Transport Provider Service"
                                                        size="sm"
                                                        placeholder="Select"
                                                        name="services"
                                                        className="md:col-span-2"
                                                        error={
                                                            errors.services &&
                                                            touched.services
                                                        }
                                                        message={
                                                            errors.services
                                                        }
                                                        value={values?.services}
                                                        disabled={
                                                            !values?.company
                                                        }
                                                        multiple
                                                        onChange={(e) =>
                                                            form.setFieldValue(
                                                                field.name,
                                                                e,
                                                            )
                                                        }
                                                    />
                                                )}
                                            </Field>
                                        )}
                                        <Field name="from_date">
                                            {({ field, form }) => (
                                                <DatePicker
                                                    className="md:col-span-2"
                                                    label="From Date"
                                                    name="from_date"
                                                    error={
                                                        errors.from_date &&
                                                        touched.from_date
                                                    }
                                                    message={errors.from_date}
                                                    value={
                                                        values?.from_date
                                                            ? dayjs(
                                                                  values?.from_date,
                                                              ).format(
                                                                  'YYYY-MM-DD',
                                                              )
                                                            : ''
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="to_date">
                                            {({ field, form }) => (
                                                <DatePicker
                                                    className="md:col-span-2"
                                                    label="To Date"
                                                    name="to_date"
                                                    error={
                                                        errors.to_date &&
                                                        touched.to_date
                                                    }
                                                    message={errors.to_date}
                                                    value={
                                                        values?.to_date
                                                            ? dayjs(
                                                                  values?.to_date,
                                                              ).format(
                                                                  'YYYY-MM-DD',
                                                              )
                                                            : ''
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="percentage">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Percentage"
                                                    name="percentage"
                                                    error={
                                                        errors.percentage &&
                                                        touched.percentage
                                                    }
                                                    message={errors.percentage}
                                                    value={values?.percentage}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="country_code">
                                            {({ field, form }) => (
                                                <Select
                                                    options={
                                                        phoneCountryCodeOptions
                                                    }
                                                    label="Country Code"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="country_code"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.country_code &&
                                                        touched.country_code
                                                    }
                                                    message={
                                                        errors.country_code
                                                    }
                                                    value={values?.country_code}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            disabled={isSubmitting}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
